
document.addEventListener('DOMContentLoaded', function() {

  if(window.innerWidth >= 768){
    var detailsElement = document.querySelector('.mobile-filter-details');

    if (detailsElement) {
      var divElement = document.createElement('div');

      divElement.innerHTML = detailsElement.innerHTML;
      for (var i = 0; i < detailsElement.attributes.length; i++) {
        var attr = detailsElement.attributes[i];
        divElement.setAttribute(attr.name, attr.value);
      }
      detailsElement.parentNode.replaceChild(divElement, detailsElement);
    }
  }
});
